import { Layout } from "antd";
import { FC, useEffect, useState } from "react";

import FooterComponent from "./Footer/Footer";
import HeaderComponent from "./Header/Header";
import SideNavComponent from "./SideNav/SideNav";

const { Content } = Layout;

const LayoutComponent: FC<{ children: JSX.Element }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isDesktop = windowWidth > 768;
  const showSideNav = isDesktop || collapsed;
  const contentPadding = isDesktop ? 24 : 2;

  return (
    <Layout id="container" style={{ minHeight: "100vh" }}>
      {showSideNav && <SideNavComponent collapsed={collapsed} />}
      <Layout>
        <HeaderComponent collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content
          style={{
            padding: contentPadding,
          }}
        >
          {children}
        </Content>
        <FooterComponent />
      </Layout>
    </Layout>
  );
};

export default LayoutComponent;
